import { Dispatch, MouseEventHandler, SetStateAction, useCallback, useEffect, useState } from 'react'
import './menu-mobile-item-default.component.scoped.scss'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

interface Props {
  title:
    | 'Início'
    | 'Creators Insight'
    | 'Conexões'
    | 'Media kit'
    | 'Todas as Campanhas'
    | 'Participações'
    | 'Inscrições'
    | 'Finalizadas'
    | 'Pagamentos'
  iconClasses?: string
  link?: string
  onClick?: MouseEventHandler<HTMLButtonElement>
  isSubItem?: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  mode: 'mobile' | 'desktop'
}

export const MainMenuItem = ({ title, link, iconClasses, onClick, isSubItem, setOpen, mode }: Props) => {
  const [active, setActive] = useState(false)
  const [isHovered, setIsHovered] = useState(false)
  const { t } = useTranslation('defaultLayout')

  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  if (onClick) {
    return (
      <button
        onClick={(event) => {
          onClick(event)
          if (mode === 'mobile') {
            setOpen(false)
          }
        }}
        className={`menu-mobile-item ${active ? 'active' : ''} ${isHovered ? 'hover' : ''} ${isSubItem ? 'subItem' : ''}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <i className={`${iconClasses} ${active || isHovered ? 'active fa-solid' : 'fa-regular'}`}></i>
        <span className={`${active ? 'active' : ''}`}>{title}</span>
      </button>
    )
  }

  return (
    <NavLink
      to={link ?? ''}
      onClick={() => {
        if (mode === 'mobile') {
          setOpen(false)
        }
      }}
      className={({ isActive }) => {
        setActive(isActive)
        return `menu-mobile-item ${isActive ? 'active' : ''} ${isSubItem ? 'subItem' : ''} ${isHovered ? 'hover' : ''}`
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <i className={`${iconClasses} ${active || isHovered ? 'active fa-solid' : 'fa-regular'}`}></i>
      <span className={`${active ? 'active' : ''}`}>{title}</span>
    </NavLink>
  )
}
